import { AuthContext } from '@/context/auth-context'
import { BrandEnum } from '@/firebase/auth/auth-jwt-schema'
import DashboardAuth from '@/routes/dashboard/auth/DashboardAuth'
import DashboardAuthHaiku from '@/routes/dashboard/auth/DashboardAuthHaiku'
import { getBrandFromHost } from '@/util/enterprise'
import { ReactNode, useContext } from 'react'

type AnonFeatureGuardProps = {
  children: ReactNode
  showAuthOnGuard: boolean
}

const hostBrand = getBrandFromHost()
/**
 * Anonymous Guard
 * Shows the sign in / sign up dialog if the user is anonymous
 */
export default function AnonFeatureGuard(props: AnonFeatureGuardProps) {
  const { children, showAuthOnGuard } = props

  // Auth context
  const authContext = useContext(AuthContext)
  const user = authContext?.user
  const userIsAnon = user?.isAnonymous

  // Allow non-anonymous users through
  if (userIsAnon == false) {
    return children
  }

  // Return the anonymous guard UX for all features except those allowed
  return showAuthOnGuard ? hostBrand === BrandEnum.HAIKU ? <DashboardAuthHaiku /> : <DashboardAuth /> : null
}
